import { createContext, useContext } from 'react';

const AudioPreloadContext = createContext<boolean>(false);

export const AudioPreloadProvider = AudioPreloadContext.Provider;

export const useAudioPreloadContext = () => useContext(AudioPreloadContext);
